<template>
  <el-card class="user-avatar-card" shadow="hover">
    <div class="card-body">
      <div class="user-info-section">
        <router-link :to="`/user/` + userAvatar.userId" class="avatar-link">
          <el-avatar :size="64" class="custom-avatar">
            <el-image :src="userAvatar.avatarUrl" fit="cover" />
          </el-avatar>
        </router-link>

        <div class="info-content">
          <div class="name-row">
            <span class="screen-name" v-html="userAvatar.screenName" />
            <el-tag v-if="userAvatar.isVip" size="mini" type="warning" effect="dark" class="vip-tag">VIP</el-tag>
          </div>
          <div class="stats-row">
            <span class="stat-item"><b>{{ userAvatar.following }}</b> 关注</span>
            <span class="stat-divider">|</span>
            <span class="stat-item"><b>{{ userAvatar.follower }}</b> 粉丝</span>
          </div>
        </div>
      </div>

      <div v-if="userAvatar.signature" class="signature-section">
        <p class="signature-text">{{ userAvatar.signature | ellipsis }}</p>
      </div>

      <div class="action-section">
        <el-button
          v-if="userAvatar.followed"
          type="info"
          size="medium"
          round
          class="follow-btn followed"
          @click="unfollowUser(userAvatar.userId)"
        >
          <i class="el-icon-check" /> <span>已关注</span>
        </el-button>
        <el-button
          v-else
          type="danger"
          size="medium"
          round
          class="follow-btn"
          @click="followUser(userAvatar.userId)"
        >
          <i class="el-icon-plus" /> <span>关注</span>
        </el-button>

        <el-button
          size="medium"
          round
          plain
          class="msg-btn"
          icon="el-icon-chat-dot-round"
          @click="sendMessage(userAvatar.userId)"
        >
          发消息
        </el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { followUser, unfollowUser } from '@/api/user'

export default {
  name: 'UserAvatarCard',
  filters: {
    ellipsis(value) {
      if (!value) return '该用户很懒，什么都没有留下'
      const max = 35
      return value.length > max ? value.slice(0, max) + '...' : value
    }
  },
  props: {
    userAvatar: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    followUser(userId) {
      followUser(userId).then(resp => {
        if (resp.code === 0) {
          this.$set(this.userAvatar, 'followed', true)
          this.userAvatar.follower++
          this.$message.success('关注成功')
        }
      })
    },
    unfollowUser(userId) {
      unfollowUser(userId).then(resp => {
        if (resp.code === 0) {
          this.$set(this.userAvatar, 'followed', false)
          this.userAvatar.follower--
          this.$message.info('取消关注')
        }
      })
    },
    sendMessage(userId) {
      this.$message.info('私信功能开发中')
    }
  }
}
</script>

<style scoped lang="scss">
.user-avatar-card {
  border-radius: 12px;
  border: none;
  background: #ffffff;
  transition: all 0.3s ease;

  .card-body {
    padding: 10px 5px;
  }
}

.user-info-section {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;

  .custom-avatar {
    border: 2px solid #fff;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    background-color: #f5f7fa;
  }

  .info-content {
    flex: 1;

    .name-row {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 4px;

      .screen-name {
        font-size: 17px;
        font-weight: 600;
        color: #303133;
      }
    }

    .stats-row {
      font-size: 13px;
      color: #909399;

      .stat-divider {
        margin: 0 8px;
        color: #e4e7ed;
      }

      b {
        color: #303133;
      }
    }
  }
}

.signature-section {
  margin-bottom: 18px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 8px;

  .signature-text {
    margin: 0;
    font-size: 12px;
    color: #606266;
    line-height: 1.5;
  }
}

.action-section {
  display: flex;
  gap: 10px;

  .follow-btn {
    flex: 1;
    font-weight: 500;

    &.followed {
      background-color: #f4f4f5;
      border-color: #e9e9eb;
      color: #909399;

      &:hover {
        background-color: #e9e9eb;
        color: #f56c6c; /* 悬停提示取消关注颜色 */
      }
    }
  }

  .msg-btn {
    flex: 1;
    color: #606266;
    border-color: #dcdfe6;

    &:hover {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
}

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .user-info-section {
    gap: 10px;
    .custom-avatar {
      width: 50px !important;
      height: 50px !important;
    }
    .screen-name {
      font-size: 15px !important;
    }
  }
  .action-section {
    .el-button {
      padding: 8px 15px;
      font-size: 12px;
    }
  }
}
</style>
